import { TableColumn } from '../../models';
import { TextSubtitleCellComponent, TextSubtitleCellProps } from './text-subtitle.component';

export class TextSubtitleColumn<I> extends TableColumn<I, TextSubtitleCellProps> {
  readonly component = TextSubtitleCellComponent;
}
